export default {"src":"/_next/static/media/gemini.35bcac20.svg","height":2577,"width":2577,"blurWidth":0,"blurHeight":0};